import TabListItemProvider from './hooks/useTabListItem';

import { TabListItemProps } from './@types/TabListItemProps';
import TabListItemContainer from './handles/TabListItemContainer';

const TabListItem = (props: TabListItemProps) => (
	<TabListItemProvider {...props}>
		<TabListItemContainer>{props.children}</TabListItemContainer>
	</TabListItemProvider>
);

export default TabListItem;
